/* eslint-disable import/no-cycle */
import i18next from 'i18next'
import { notification } from 'antd'
import { getReq } from './request'

/**
 * Otvorí PDF z chráneného endpointu v novom tabe.
 *
 * window.open na URL nestačí - endpointy preberacích protokolov sú za prihlásením a v novom
 * tabe by sa nedostal Authorization header. Preto sa PDF stiahne cez axios a otvorí sa ako blob.
 *
 * @param url relatívna cesta k endpointu vrátane query stringu
 */
// eslint-disable-next-line import/prefer-default-export
export const openPdfInNewTab = async (url: string) => {
	// tab treba otvoriť ešte v rámci kliknutia, inak ho prehliadač zablokuje ako vyskakovacie okno
	const tab = window.open('', '_blank')

	try {
		const res = await getReq(url, undefined, { responseType: 'blob' })
		const blobUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))

		if (tab) {
			tab.location.href = blobUrl
		} else {
			// prehliadač tab nepovolil - otvoríme dokument aspoň v aktuálnom okne
			window.location.href = blobUrl
		}

		// URL sa uvoľní až keď ju prehliadač stihne načítať
		setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
	} catch (e) {
		if (tab) {
			tab.close()
		}
		notification.error({
			message: i18next.t('loc:Chyba'),
			description: i18next.t('loc:Preberací protokol sa nepodarilo vygenerovať')
		})
	}
}
